
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/community-guidelines",
      function () {
        return require("private-next-pages/docs/community-guidelines.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/community-guidelines"])
      });
    }
  